import { log, supabase } from ".";

/**
 * Genera el código para una oportunidad clonada
 * Ej: OCUWBB -> OCUWBB-v2, OCUWBB-v2 -> OCUWBB-v3
 */
const generateCloneCode = (originalCode) => {
  if (!originalCode) return null;

  // Verificar si ya tiene sufijo de versión
  const versionMatch = originalCode.match(/-v(\d+)$/);

  if (versionMatch) {
    // Ya tiene versión, incrementar
    const currentVersion = parseInt(versionMatch[1], 10);
    const baseCode = originalCode.replace(/-v\d+$/, "");
    return `${baseCode}-v${currentVersion + 1}`;
  }

  // No tiene versión, agregar -v2
  return `${originalCode}-v2`;
};

/**
 * Clona una oportunidad existente creando una nueva entrada en la BD
 * @param {Object} oportunidad - La oportunidad a clonar
 * @returns {Object} La nueva oportunidad clonada con su ID
 */
export const cloneOportunidad = async (oportunidad) => {
  try {
    if (!oportunidad || !oportunidad.id) {
      throw new Error("Oportunidad inválida para clonar");
    }

    // Campos que NO se deben clonar
    const excludeFields = [
      "id",
      "created_at",
      "updated_at",
      "facturafecha",
      "facturanumero",
      "facturafechacobro",
      "plazocobro",
      "fecha_cierre",
    ];

    // Crear copia limpia de la oportunidad
    const clonedData = {};

    for (const [key, value] of Object.entries(oportunidad)) {
      if (!excludeFields.includes(key)) {
        clonedData[key] = value;
      }
    }

    // Generar nuevo código con sufijo de versión
    clonedData.code = generateCloneCode(oportunidad.code);

    // Resetear versión a 1 (es una nueva oportunidad)
    clonedData.version = "1";

    // Resetear campos de descuento manual si existían
    clonedData.has_manual_discount = false;
    clonedData.manual_discount_amount = null;
    clonedData.original_amount = null;

    // Mantener el estatus original pero podría ser útil resetearlo
    // clonedData.estatus = "75%"; // Descomentar si se quiere resetear

    const data = await supabase.insert("sales", clonedData);

    if (!data || data.length === 0) {
      throw new Error("Error al insertar oportunidad clonada");
    }

    return data[0];
  } catch (error) {
    log.error("cloneOportunidad", error);
    throw error;
  }
};
